import { __decorate, __param } from './external/tslib/tslib.es6.js';
import './missing-services.js';
import './vscode/src/vs/workbench/api/common/jsonValidationExtensionPoint.js';
import './vscode/src/vs/workbench/services/themes/common/colorExtensionPoint.js';
import './vscode/src/vs/workbench/services/themes/common/iconExtensionPoint.js';
import './vscode/src/vs/platform/actions/common/actions.contribution.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/workbenchReferenceSearch.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/menuPreventer.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/diffEditorHelper.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/largeFileOptimizations.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/saveParticipants.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/toggleMinimap.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/toggleMultiCursorModifier.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/toggleRenderControlCharacter.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/toggleWordWrap.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/toggleRenderWhitespace.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/editorLineNumberMenu.js';
import './vscode/src/vs/workbench/contrib/format/browser/formatActionsMultiple.js';
import './vscode/src/vs/workbench/contrib/format/browser/formatActionsNone.js';
import './vscode/src/vs/workbench/contrib/format/browser/formatModified.js';
import './vscode/src/vs/workbench/contrib/folding/browser/folding.contribution.js';
import './vscode/src/vs/workbench/contrib/inlayHints/browser/inlayHintsAccessibilty.js';
import './vscode/src/vs/workbench/contrib/codeActions/browser/codeActions.contribution.js';
import './vscode/src/vs/workbench/contrib/list/browser/list.contribution.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/editorFeatures.js';
import './vscode/src/vs/workbench/contrib/contextmenu/browser/contextmenu.contribution.js';
import './vscode/src/vs/workbench/contrib/mappedEdits/common/mappedEdits.contribution.js';
import './vscode/src/vs/workbench/browser/actions/textInputActions.js';
import './vscode/src/vs/workbench/browser/actions/developerActions.js';
import './vscode/src/vs/editor/browser/coreCommands.js';
import './vscode/src/vs/editor/browser/widget/codeEditor/codeEditorWidget.js';
import './vscode/src/vs/editor/browser/widget/diffEditor/diffEditor.contribution.js';
import './vscode/src/vs/editor/contrib/anchorSelect/browser/anchorSelect.js';
import './vscode/src/vs/editor/contrib/bracketMatching/browser/bracketMatching.js';
import './vscode/src/vs/editor/contrib/caretOperations/browser/caretOperations.js';
import './vscode/src/vs/editor/contrib/caretOperations/browser/transpose.js';
import './vscode/src/vs/editor/contrib/clipboard/browser/clipboard.js';
import './vscode/src/vs/editor/contrib/codeAction/browser/codeActionContributions.js';
import './vscode/src/vs/editor/contrib/codelens/browser/codelensController.js';
import './vscode/src/vs/editor/contrib/colorPicker/browser/colorContributions.js';
import './vscode/src/vs/editor/contrib/colorPicker/browser/standaloneColorPickerActions.js';
import './vscode/src/vs/editor/contrib/comment/browser/comment.js';
import './vscode/src/vs/editor/contrib/contextmenu/browser/contextmenu.js';
import './vscode/src/vs/editor/contrib/cursorUndo/browser/cursorUndo.js';
import './vscode/src/vs/editor/contrib/dnd/browser/dnd.js';
import './vscode/src/vs/editor/contrib/dropOrPasteInto/browser/copyPasteContribution.js';
import './vscode/src/vs/editor/contrib/dropOrPasteInto/browser/dropIntoEditorContribution.js';
import './vscode/src/vs/editor/contrib/find/browser/findController.js';
import './vscode/src/vs/editor/contrib/folding/browser/folding.js';
import './vscode/src/vs/editor/contrib/fontZoom/browser/fontZoom.js';
import './vscode/src/vs/editor/contrib/format/browser/formatActions.js';
import './vscode/src/vs/editor/contrib/documentSymbols/browser/documentSymbols.js';
import './vscode/src/vs/editor/contrib/inlineCompletions/browser/inlineCompletions.contribution.js';
import './vscode/src/vs/editor/contrib/inlineProgress/browser/inlineProgress.js';
import './vscode/src/vs/editor/contrib/gotoSymbol/browser/goToCommands.js';
import './vscode/src/vs/editor/contrib/gotoSymbol/browser/link/goToDefinitionAtPosition.js';
import './vscode/src/vs/editor/contrib/gotoError/browser/gotoError.js';
import './vscode/src/vs/editor/contrib/hover/browser/hoverContribution.js';
import './vscode/src/vs/editor/contrib/indentation/browser/indentation.js';
import './vscode/src/vs/editor/contrib/inlayHints/browser/inlayHintsContribution.js';
import './vscode/src/vs/editor/contrib/inPlaceReplace/browser/inPlaceReplace.js';
import './vscode/src/vs/editor/contrib/lineSelection/browser/lineSelection.js';
import './vscode/src/vs/editor/contrib/linesOperations/browser/linesOperations.js';
import './vscode/src/vs/editor/contrib/linkedEditing/browser/linkedEditing.js';
import './vscode/src/vs/editor/contrib/links/browser/links.js';
import './vscode/src/vs/editor/contrib/longLinesHelper/browser/longLinesHelper.js';
import './vscode/src/vs/editor/contrib/multicursor/browser/multicursor.js';
import './vscode/src/vs/editor/contrib/inlineEdit/browser/inlineEdit.contribution.js';
import './vscode/src/vs/editor/contrib/parameterHints/browser/parameterHints.js';
import './vscode/src/vs/editor/contrib/rename/browser/rename.js';
import './vscode/src/vs/editor/contrib/sectionHeaders/browser/sectionHeaders.js';
import './vscode/src/vs/editor/contrib/semanticTokens/browser/documentSemanticTokens.js';
import './vscode/src/vs/editor/contrib/semanticTokens/browser/viewportSemanticTokens.js';
import './vscode/src/vs/editor/contrib/smartSelect/browser/smartSelect.js';
import './vscode/src/vs/editor/contrib/snippet/browser/snippetController2.js';
import './vscode/src/vs/editor/contrib/stickyScroll/browser/stickyScrollContribution.js';
import './vscode/src/vs/editor/contrib/suggest/browser/suggestController.js';
import './vscode/src/vs/editor/contrib/suggest/browser/suggestInlineCompletions.js';
import './vscode/src/vs/editor/contrib/tokenization/browser/tokenization.js';
import './vscode/src/vs/editor/contrib/toggleTabFocusMode/browser/toggleTabFocusMode.js';
import './vscode/src/vs/editor/contrib/unicodeHighlighter/browser/unicodeHighlighter.js';
import './vscode/src/vs/editor/contrib/unusualLineTerminators/browser/unusualLineTerminators.js';
import './vscode/src/vs/editor/contrib/wordHighlighter/browser/wordHighlighter.js';
import './vscode/src/vs/editor/contrib/wordOperations/browser/wordOperations.js';
import './vscode/src/vs/editor/contrib/wordPartOperations/browser/wordPartOperations.js';
import './vscode/src/vs/editor/contrib/readOnlyMessage/browser/contribution.js';
import './vscode/src/vs/editor/contrib/diffEditorBreadcrumbs/browser/contribution.js';
import './vscode/src/vs/editor/common/standaloneStrings.js';
import './vscode/src/vs/base/browser/ui/codicons/codicon/codicon.css.js';
import './vscode/src/vs/base/browser/ui/codicons/codicon/codicon-modifiers.css.js';
import './vscode/src/vs/editor/standalone/browser/iPadShowKeyboard/iPadShowKeyboard.js';
export { default as Severity } from './vscode/src/vs/base/common/severity.js';
export { StorageScope, StorageTarget } from './vscode/src/vs/platform/storage/common/storage.js';
import { StandaloneServices } from './vscode/src/vs/editor/standalone/browser/standaloneServices.js';
import { mixin } from './vscode/src/vs/base/common/objects.js';
import { IInstantiationService } from './vscode/src/vs/platform/instantiation/common/instantiation.js';
import { DisposableStore } from './vscode/src/vs/base/common/lifecycle.js';
import { registerWorkbenchContribution2 } from './vscode/src/vs/workbench/common/contributions.js';
export { WorkbenchPhase } from './vscode/src/vs/workbench/common/contributions.js';
import { IProductService } from './vscode/src/vs/platform/product/common/productService.service.js';
import { initialize as initialize$1 } from './workbench.js';
import { checkServicesNotInitialized, startup, waitServicesReady, checkServicesReady, serviceInitializedBarrier, serviceInitializedEmitter } from './lifecycle.js';
import getServiceOverride$2$1 from '@codingame/monaco-vscode-quickaccess-service-override';
import getServiceOverride$1$1 from '@codingame/monaco-vscode-files-service-override';
import getServiceOverride$2 from '@codingame/monaco-vscode-extensions-service-override';
import getServiceOverride$1 from '@codingame/monaco-vscode-environment-service-override';
import getServiceOverride from '@codingame/monaco-vscode-layout-service-override';
import getServiceOverride$5 from '@codingame/monaco-vscode-host-service-override';
import getServiceOverride$6 from '@codingame/monaco-vscode-base-service-override';
export { SyncDescriptor } from './vscode/src/vs/platform/instantiation/common/descriptors.js';
export { ICommandService } from './vscode/src/vs/platform/commands/common/commands.service.js';
export { INotificationService } from './vscode/src/vs/platform/notification/common/notification.service.js';
export { IBulkEditService } from './vscode/src/vs/editor/browser/services/bulkEditService.js';
export { ICodeEditorService } from './vscode/src/vs/editor/browser/services/codeEditorService.js';
export { ILanguageService } from './vscode/src/vs/editor/common/languages/language.js';
export { ILanguageConfigurationService } from './vscode/src/vs/editor/common/languages/languageConfigurationRegistry.js';
export { IEditorWorkerService } from './vscode/src/vs/editor/common/services/editorWorker.js';
export { ILanguageFeaturesService } from './vscode/src/vs/editor/common/services/languageFeatures.js';
export { IModelService } from './vscode/src/vs/editor/common/services/model.js';
export { ITextModelService } from './vscode/src/vs/editor/common/services/resolverService.js';
export { IClipboardService } from './vscode/src/vs/platform/clipboard/common/clipboardService.service.js';
export { IDialogService, IFileDialogService } from './vscode/src/vs/platform/dialogs/common/dialogs.service.js';
export { IFileService } from './vscode/src/vs/platform/files/common/files.service.js';
export { IMarkerService } from './vscode/src/vs/platform/markers/common/markers.service.js';
export { IOpenerService } from './vscode/src/vs/platform/opener/common/opener.service.js';
export { IQuickInputService } from './vscode/src/vs/platform/quickinput/common/quickInput.service.js';
export { ITelemetryService } from './vscode/src/vs/platform/telemetry/common/telemetry.service.js';
export { IUriIdentityService } from './vscode/src/vs/platform/uriIdentity/common/uriIdentity.service.js';
export { IBreadcrumbsService } from './vscode/src/vs/workbench/browser/parts/editor/breadcrumbs.service.js';
export { IEditorGroupsService } from './vscode/src/vs/workbench/services/editor/common/editorGroupsService.service.js';
export { GroupDirection, GroupLocation, GroupOrientation, GroupsArrangement, GroupsOrder, MergeGroupMode } from './vscode/src/vs/workbench/services/editor/common/editorGroupsService.js';
export { CloseDirection, EditorsOrder } from './vscode/src/vs/workbench/common/editor.js';
export { EditorInput } from './vscode/src/vs/workbench/common/editor/editorInput.js';
export { IEditorService } from './vscode/src/vs/workbench/services/editor/common/editorService.service.js';
export { IEditorResolverService } from './vscode/src/vs/workbench/services/editor/common/editorResolverService.service.js';
export { ITextEditorService } from './vscode/src/vs/workbench/services/textfile/common/textEditorService.service.js';
export { IWorkbenchEnvironmentService } from './vscode/src/vs/workbench/services/environment/common/environmentService.service.js';
export { IHostService } from './vscode/src/vs/workbench/services/host/browser/host.service.js';
export { ILanguageStatusService } from './vscode/src/vs/workbench/services/languageStatus/common/languageStatusService.service.js';
export { IPaneCompositePartService } from './vscode/src/vs/workbench/services/panecomposite/browser/panecomposite.service.js';
export { IPathService } from './vscode/src/vs/workbench/services/path/common/pathService.service.js';
export { ITextFileService } from './vscode/src/vs/workbench/services/textfile/common/textfiles.service.js';
export { IWorkingCopyFileService } from './vscode/src/vs/workbench/services/workingCopy/common/workingCopyFileService.service.js';
export { IConfigurationService } from './vscode/src/vs/platform/configuration/common/configuration.service.js';
export { IContextKeyService } from './vscode/src/vs/platform/contextkey/common/contextkey.service.js';
export { IThemeService } from './vscode/src/vs/platform/theme/common/themeService.service.js';
export { ISnippetsService } from './vscode/src/vs/workbench/contrib/snippets/browser/snippets.service.js';
export { IWorkspaceContextService } from './vscode/src/vs/platform/workspace/common/workspace.service.js';
export { IStorageService } from './vscode/src/vs/platform/storage/common/storage.service.js';
export { IAccessibilitySignalService } from './vscode/src/vs/platform/accessibilitySignal/browser/accessibilitySignalService.service.js';
export { IDebugService } from './vscode/src/vs/workbench/contrib/debug/common/debug.service.js';
export { ILogService, ILoggerService } from './vscode/src/vs/platform/log/common/log.service.js';
export { LogLevel } from './vscode/src/vs/platform/log/common/log.js';
export { IViewDescriptorService } from './vscode/src/vs/workbench/common/views.service.js';
export { IViewsService } from './vscode/src/vs/workbench/services/views/common/viewsService.service.js';
export { ILayoutService } from './vscode/src/vs/platform/layout/browser/layoutService.service.js';
export { IPreferencesService } from './vscode/src/vs/workbench/services/preferences/common/preferences.service.js';
export { IPreferencesSearchService } from './vscode/src/vs/workbench/contrib/preferences/common/preferences.service.js';
export { IKeybindingEditingService } from './vscode/src/vs/workbench/services/keybinding/common/keybindingEditing.service.js';
export { IOutputService } from './vscode/src/vs/workbench/services/output/common/output.service.js';
export { IHistoryService } from './vscode/src/vs/workbench/services/history/common/history.service.js';
export { GoFilter, GoScope } from './vscode/src/vs/workbench/services/history/common/history.js';
export { IRemoteAgentService } from './vscode/src/vs/workbench/services/remote/common/remoteAgentService.service.js';
export { IRemoteAuthorityResolverService } from './vscode/src/vs/platform/remote/common/remoteAuthorityResolver.service.js';
export { IRemoteSocketFactoryService } from './vscode/src/vs/platform/remote/common/remoteSocketFactoryService.service.js';
export { IFilesConfigurationService } from './vscode/src/vs/workbench/services/filesConfiguration/common/filesConfigurationService.service.js';
export { ILabelService } from './vscode/src/vs/platform/label/common/label.service.js';
export { IWorkbenchLayoutService } from './vscode/src/vs/workbench/services/layout/browser/layoutService.service.js';
export { ILanguagePackService } from './vscode/src/vs/platform/languagePacks/common/languagePacks.service.js';
export { ILocaleService } from './vscode/src/vs/workbench/services/localization/common/locale.service.js';
export { NeverShowAgainScope, NoOpNotification, NoOpProgress, NotificationPriority, NotificationsFilter } from './vscode/src/vs/platform/notification/common/notification.js';
export { IActivityService } from './vscode/src/vs/workbench/services/activity/common/activity.service.js';
export { IHoverService } from './vscode/src/vs/platform/hover/browser/hover.service.js';
export { IExplorerService } from './vscode/src/vs/workbench/contrib/files/browser/files.service.js';
export { IStatusbarService } from './vscode/src/vs/workbench/services/statusbar/browser/statusbar.service.js';
export { ITitleService } from './vscode/src/vs/workbench/services/title/browser/titleService.service.js';
export { IBannerService } from './vscode/src/vs/workbench/services/banner/browser/bannerService.service.js';
export { IWorkspaceTrustEnablementService, IWorkspaceTrustManagementService, IWorkspaceTrustRequestService } from './vscode/src/vs/platform/workspace/common/workspaceTrust.service.js';
export { IKeybindingService } from './vscode/src/vs/platform/keybinding/common/keybinding.service.js';
export { ISecretStorageService } from './vscode/src/vs/platform/secrets/common/secrets.service.js';
async function initialize(overrides, container = document.body, configuration = {}, env) {
    checkServicesNotInitialized();
    initialize$1(container, configuration, env);
    const instantiationService = StandaloneServices.initialize({
        [( IProductService.toString())]: mixin({
            version: "1.89.1",
            quality: 'stable',
            commit: "dc96b837cf6bb4af9cd736aa3af08cf8279f7685",
            nameShort: 'Code - OSS',
            nameLong: 'Code - OSS',
            applicationName: 'code-oss',
            dataFolderName: '.vscode-oss',
            urlProtocol: 'code-oss',
            reportIssueUrl: 'https://github.com/microsoft/vscode/issues/new',
            licenseName: 'MIT',
            licenseUrl: 'https://github.com/microsoft/vscode/blob/main/LICENSE.txt',
            serverApplicationName: 'code-server-oss'
        }, configuration.productConfiguration ?? {}),
        ...getServiceOverride(),
        ...getServiceOverride$1(),
        ...getServiceOverride$2(),
        ...getServiceOverride$1$1(),
        ...getServiceOverride$2$1(),
        ...getServiceOverride$5(),
        ...getServiceOverride$6(),
        ...overrides
    });
    await startup(instantiationService);
}
async function getService(identifier) {
    await waitServicesReady();
    return StandaloneServices.get(identifier);
}
async function createInstance(ctor, ...args) {
    await waitServicesReady();
    return StandaloneServices.get(IInstantiationService).createInstance(ctor, ...args);
}
function createInstanceSync(ctor, ...args) {
    checkServicesReady();
    return StandaloneServices.get(IInstantiationService).createInstance(ctor, ...args);
}
function withReadyServices(callback) {
    if (serviceInitializedBarrier.isOpen()) {
        return StandaloneServices.get(IInstantiationService).invokeFunction(callback);
    }
    const disposable = new DisposableStore();
    const listener = disposable.add(serviceInitializedEmitter.event(() => {
        listener.dispose();
        disposable.add(StandaloneServices.get(IInstantiationService).invokeFunction(callback));
    }));
    return disposable;
}
const registerWorkbenchContribution = (id, contribution, instantiation) => {
    let Contribution = class Contribution {
        constructor(instantiationService) {
            instantiationService.invokeFunction(contribution);
        }
    };
    Contribution = __decorate([
        ( __param(0, IInstantiationService))
    ], Contribution);
    registerWorkbenchContribution2(id, Contribution, instantiation);
};
export { IInstantiationService, IProductService, StandaloneServices, createInstance, createInstanceSync, getService, initialize, registerWorkbenchContribution, withReadyServices };
